export const countryCodes = [
  { code: 'AD', name: 'Andorra', flag: 'andorra' },
  { code: 'AE', name: 'United Arab Emirates', flag: 'dubai' },
  { code: 'AF', name: 'Afghanistan', flag: 'afghanistan' },
  { code: 'AG', name: 'Antigua And Barbuda', flag: 'antiguabarbuda' },
  { code: 'AI', name: 'Anguilla', flag: 'anguilla' },
  { code: 'AL', name: 'Albania', flag: 'albania' },
  { code: 'AM', name: 'Armenia', flag: 'armenia' },
  { code: 'AO', name: 'Angola', flag: 'angola' },
  { code: 'AQ', name: 'Antarctica', flag: 'antarctica' },
  { code: 'AR', name: 'Argentina', flag: 'argentina' },
  { code: 'AS', name: 'American Samoa', flag: 'americansamoa' },
  { code: 'AT', name: 'Austria', flag: 'austria' },
  { code: 'AU', name: 'Australia', flag: 'australia' },
  { code: 'AW', name: 'Aruba', flag: 'aruba' },
  { code: 'AX', name: 'Aland Islands', flag: 'worldwide' },
  { code: 'AZ', name: 'Azerbaijan', flag: 'azerbaijan' },
  { code: 'BA', name: 'Bosnia And Herzegovina', flag: 'bosnia' },
  { code: 'BB', name: 'Barbados', flag: 'barbados' },
  { code: 'BD', name: 'Bangladesh', flag: 'bangladesh' },
  { code: 'BE', name: 'Belgium', flag: 'belgium' },
  { code: 'BF', name: 'Burkina Faso', flag: 'burkinafaso' },
  { code: 'BG', name: 'Bulgaria', flag: 'bulgaria' },
  { code: 'BH', name: 'Bahrain', flag: 'bahrain' },
  { code: 'BI', name: 'Burundi', flag: 'burundi' },
  { code: 'BJ', name: 'Benin', flag: 'benin' },
  { code: 'BL', name: 'Saint Barthelemy', flag: 'worldwide' },
  { code: 'BM', name: 'Bermuda', flag: 'bermuda' },
  { code: 'BN', name: 'Brunei Darussalam', flag: 'brunei' },
  { code: 'BO', name: 'Bolivia', flag: 'bolivia' },
  { code: 'BQ', name: 'Bonaire Sint Eustatius and Saba', flag: 'worldwide' },
  { code: 'BR', name: 'Brazil', flag: 'brazil' },
  { code: 'BS', name: 'Bahamas', flag: 'bahamas' },
  { code: 'BT', name: 'Bhutan', flag: 'bhutan' },
  { code: 'BV', name: 'Bouvet Island', flag: 'bouvet_island' },
  { code: 'BW', name: 'Botswana', flag: 'botswana' },
  { code: 'BY', name: 'Belarus', flag: 'belarus' },
  { code: 'BZ', name: 'Belize', flag: 'belize' },
  { code: 'CA', name: 'Canada', flag: 'canada' },
  { code: 'CC', name: 'Cocos (Keeling) Islands', flag: 'worldwide' },
  {
    code: 'CD',
    name: 'Congo the Democratic Republic of the',
    flag: 'kinshasazaire'
  },
  {
    code: 'CF',
    name: 'Central African Republic',
    flag: 'central_african_republic'
  },
  { code: 'CG', name: 'Congo', flag: 'brazzaville' },
  { code: 'CH', name: 'Switzerland', flag: 'switzerland' },
  { code: 'CI', name: "Cote D'Ivoire", flag: 'cote_divoire' },
  { code: 'CK', name: 'Cook Islands', flag: 'cook_islands' },
  { code: 'CL', name: 'Chile', flag: 'chile' },
  { code: 'CM', name: 'Cameroon', flag: 'cameroon' },
  { code: 'CN', name: 'China', flag: 'china' },
  { code: 'CO', name: 'Colombia', flag: 'colombia' },
  { code: 'CR', name: 'Costa Rica', flag: 'costa_rica' },
  { code: 'CU', name: 'Cuba', flag: 'cuba' },
  { code: 'CV', name: 'Cape Verde', flag: 'cape_verde' },
  { code: 'CW', name: 'Curaçao', flag: 'worldwide' },
  { code: 'CX', name: 'Christmas Island', flag: 'worldwide' },
  { code: 'CY', name: 'Cyprus', flag: 'cyprus' },
  { code: 'CZ', name: 'Czech Republic', flag: 'czech_republic' },
  { code: 'DE', name: 'Germany', flag: 'germany' },
  { code: 'DJ', name: 'Djibouti', flag: 'djibouti' },
  { code: 'DK', name: 'Denmark', flag: 'denmark' },
  { code: 'DM', name: 'Dominica', flag: 'dominica' },
  { code: 'DO', name: 'Dominican Republic', flag: 'dominican_republic' },
  { code: 'DZ', name: 'Algeria', flag: 'algeria' },
  { code: 'EC', name: 'Ecuador', flag: 'ecuador' },
  { code: 'EE', name: 'Estonia', flag: 'estonia' },
  { code: 'EG', name: 'Egypt', flag: 'egypt' },
  { code: 'EH', name: 'Western Sahara', flag: 'worldwide' },
  { code: 'ER', name: 'Eritrea', flag: 'eritrea' },
  { code: 'ES', name: 'Spain', flag: 'spain' },
  { code: 'ET', name: 'Ethiopia', flag: 'ethiopia' },
  { code: 'FI', name: 'Finland', flag: 'finland' },
  { code: 'FJ', name: 'Fiji', flag: 'fiji' },
  { code: 'FK', name: 'Falkland Islands (Malvinas)', flag: 'worldwide' },
  { code: 'FM', name: 'Micronesia, Federated States Of', flag: 'micronesia' },
  { code: 'FO', name: 'Faroe Islands', flag: 'faroe_islands' },
  { code: 'FR', name: 'France', flag: 'france' },
  { code: 'GA', name: 'Gabon', flag: 'gabon' },
  { code: 'GB', name: 'United Kingdom', flag: 'uk' },
  { code: 'GD', name: 'Grenada', flag: 'grenada' },
  { code: 'GE', name: 'Georgia', flag: 'georgia' },
  { code: 'GF', name: 'French Guiana', flag: 'french_guiana' },
  { code: 'GG', name: 'Guernsey', flag: 'worldwide' },
  { code: 'GH', name: 'Ghana', flag: 'ghana' },
  { code: 'GI', name: 'Gibraltar', flag: 'gibraltar' },
  { code: 'GL', name: 'Greenland', flag: 'greenland' },
  { code: 'GM', name: 'Gambia', flag: 'gambia' },
  { code: 'GN', name: 'Guinea', flag: 'guinea' },
  { code: 'GP', name: 'Guadeloupe', flag: 'guadeloupe' },
  { code: 'GQ', name: 'Equatorial Guinea', flag: 'equatorialguinea' },
  { code: 'GR', name: 'Greece', flag: 'greece' },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    flag: 'worldwide'
  },
  { code: 'GT', name: 'Guatemala', flag: 'guatemala' },
  { code: 'GU', name: 'Guam', flag: 'guam' },
  { code: 'GW', name: 'Guinea-Bissau', flag: 'guinea-bissau' },
  { code: 'GY', name: 'Guyana', flag: 'guyana' },
  { code: 'HK', name: 'Hong Kong', flag: 'hong_kong' },
  { code: 'HM', name: 'Heard Island and McDonald Islands', flag: 'worldwide' },
  { code: 'HN', name: 'Honduras', flag: 'honduras' },
  { code: 'HR', name: 'Croatia', flag: 'croatia' },
  { code: 'HT', name: 'Haiti', flag: 'haiti' },
  { code: 'HU', name: 'Hungary', flag: 'hungary' },
  { code: 'ID', name: 'Indonesia', flag: 'indonesia' },
  { code: 'IE', name: 'Ireland', flag: 'ireland' },
  { code: 'IL', name: 'Israel', flag: 'israel' },
  { code: 'IM', name: 'Isle of Man', flag: 'worldwide' },
  { code: 'IN', name: 'India', flag: 'india' },
  { code: 'IO', name: 'British Indian Ocean Territory', flag: 'worldwide' },
  { code: 'IQ', name: 'Iraq', flag: 'iraq' },
  { code: 'IR', name: 'Iran Islamic Republic Of', flag: 'iran' },
  { code: 'IS', name: 'Iceland', flag: 'iceland' },
  { code: 'IT', name: 'Italy', flag: 'italy' },
  { code: 'JE', name: 'Jersey', flag: 'worldwide' },
  { code: 'JM', name: 'Jamaica', flag: 'jamaica' },
  { code: 'JO', name: 'Jordan', flag: 'jordan' },
  { code: 'JP', name: 'Japan', flag: 'japan' },
  { code: 'KE', name: 'Kenya', flag: 'kenya' },
  { code: 'KG', name: 'Kyrgyzstan', flag: 'kyrgyzstan' },
  { code: 'KH', name: 'Cambodia', flag: 'cambodja' },
  { code: 'KI', name: 'Kiribati', flag: 'kiribati' },
  { code: 'KM', name: 'Comoros', flag: 'comoros' },
  { code: 'KN', name: 'Saint Kitts and Nevis', flag: 'stkittsnevis' },
  {
    code: 'KP',
    name: 'North Korea',
    flag: 'northkorea',
    tags: "Korea Democratic People's Republic of"
  },
  {
    code: 'KR',
    name: 'South Korea',
    flag: 'south_korea',
    tags: 'Korea Republic of'
  },
  { code: 'KW', name: 'Kuwait', flag: 'kuwait' },
  { code: 'KY', name: 'Cayman Islands', flag: 'cayman_islands' },
  { code: 'KZ', name: 'Kazakhstan', flag: 'kazakhstan' },
  { code: 'LA', name: "Lao People's Democratic Republic", flag: 'laos' },
  { code: 'LB', name: 'Lebanon', flag: 'lebanon' },
  { code: 'LC', name: 'Saint Lucia', flag: 'saintlucia' },
  { code: 'LI', name: 'Liechtenstein', flag: 'liechtenstein' },
  { code: 'LK', name: 'Sri Lanka', flag: 'sri_lanka' },
  { code: 'LR', name: 'Liberia', flag: 'liberia' },
  { code: 'LS', name: 'Lesotho', flag: 'lesotho' },
  { code: 'LT', name: 'Lithuania', flag: 'lithuania' },
  { code: 'LU', name: 'Luxembourg', flag: 'luxembourg' },
  { code: 'LV', name: 'Latvia', flag: 'latvia' },
  { code: 'LW', name: 'Last World', flag: 'worldwide' },
  { code: 'LY', name: 'Libyan Arab Jamahiriya', flag: 'libya' },
  { code: 'MA', name: 'Morocco', flag: 'morocco' },
  { code: 'MC', name: 'Monaco', flag: 'monaco' },
  { code: 'MD', name: 'Moldova', flag: 'moldova' },
  { code: 'ME', name: 'Montenegro', flag: 'montenegro' },
  { code: 'MF', name: 'Saint Martin (French part)', flag: 'worldwide' },
  { code: 'MG', name: 'Madagascar', flag: 'madagascar' },
  { code: 'MH', name: 'Marshall Islands', flag: 'marshallislands' },
  { code: 'MK', name: 'Macedonia', flag: 'macedonia' },
  { code: 'ML', name: 'Mali', flag: 'mali' },
  { code: 'MM', name: 'Myanmar Burma', flag: 'myanmarburma' },
  { code: 'MN', name: 'Mongolia', flag: 'mongolia' },
  { code: 'MO', name: 'Macao', flag: 'macao' },
  { code: 'MP', name: 'Northern Mariana Islands', flag: 'worldwide' },
  { code: 'MQ', name: 'Martinique', flag: 'martinique' },
  { code: 'MR', name: 'Mauritania', flag: 'mauritania' },
  { code: 'MS', name: 'Montserrat', flag: 'montserrat' },
  { code: 'MT', name: 'Malta', flag: 'malta' },
  { code: 'MU', name: 'Mauritius', flag: 'mauritius' },
  { code: 'MV', name: 'Maldives', flag: 'maldives' },
  { code: 'MW', name: 'Malawi', flag: 'malawi' },
  { code: 'MX', name: 'Mexico', flag: 'mexico' },
  { code: 'MY', name: 'Malaysia', flag: 'malaysia' },
  { code: 'MZ', name: 'Mozambique', flag: 'mozambique' },
  { code: 'NA', name: 'Namibia', flag: 'namibia' },
  { code: 'NC', name: 'New Caledonia', flag: 'worldwide' },
  { code: 'NE', name: 'Niger', flag: 'niger' },
  { code: 'NF', name: 'Norfolk Island', flag: 'norfolk_island' },
  { code: 'NG', name: 'Nigeria', flag: 'nigeria' },
  { code: 'NI', name: 'Nicaragua', flag: 'nicaragua' },
  { code: 'NL', name: 'Netherlands', flag: 'netherlands' },
  { code: 'NO', name: 'Norway', flag: 'norway' },
  { code: 'NP', name: 'Nepal', flag: 'nepal' },
  { code: 'NR', name: 'Nauru', flag: 'nauru' },
  { code: 'NU', name: 'Niue', flag: 'worldwide' },
  { code: 'NZ', name: 'New Zealand', flag: 'new_zealand' },
  { code: 'OM', name: 'Oman', flag: 'oman' },
  { code: 'PA', name: 'Panama', flag: 'panama' },
  { code: 'PE', name: 'Peru', flag: 'peru' },
  { code: 'PF', name: 'French Polynesia', flag: 'tahitifrenchpolinesia' },
  { code: 'PG', name: 'Papua New Guinea', flag: 'papua_new_guinea' },
  { code: 'PH', name: 'Philippines', flag: 'philippines' },
  { code: 'PK', name: 'Pakistan', flag: 'pakistan' },
  { code: 'PL', name: 'Poland', flag: 'poland' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', flag: 'worldwide' },
  { code: 'PN', name: 'Pitcairn', flag: 'worldwide' },
  { code: 'PR', name: 'Puerto Rico', flag: 'puertorico' },
  { code: 'PS', name: 'State of Palestine', flag: 'palestine' },
  { code: 'PT', name: 'Portugal', flag: 'portugal' },
  { code: 'PW', name: 'Palau', flag: 'palau' },
  { code: 'PY', name: 'Paraguay', flag: 'paraguay' },
  { code: 'QA', name: 'Qatar', flag: 'qatar' },
  { code: 'RE', name: 'Reunion', flag: 'reunion' },
  { code: 'RO', name: 'Romania', flag: 'romania' },
  { code: 'RS', name: 'Serbia', flag: 'serbia' },
  { code: 'RU', name: 'Russian Federation', flag: 'russian_federation' },
  { code: 'RW', name: 'Rwanda', flag: 'rwanda' },
  { code: 'SA', name: 'Saudi Arabia', flag: 'saudi_arabia' },
  { code: 'SB', name: 'Solomon Islands', flag: 'solomon_islands' },
  { code: 'SC', name: 'Seychelles', flag: 'seychelles' },
  { code: 'SD', name: 'Sudan', flag: 'sudan' },
  { code: 'SE', name: 'Sweden', flag: 'sweden' },
  { code: 'SG', name: 'Singapore', flag: 'singapore' },
  {
    code: 'SH',
    name: 'Saint Helena Ascension and Tristan da Cunha',
    flag: 'worldwide'
  },
  { code: 'SI', name: 'Slovenia', flag: 'slovenia' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', flag: 'worldwide' },
  { code: 'SK', name: 'Slovakia', flag: 'slovakia' },
  { code: 'SL', name: 'Sierra Leone', flag: 'sierraleone' },
  { code: 'SM', name: 'San Marino', flag: 'sanmarino' },
  { code: 'SN', name: 'Senegal', flag: 'senegal' },
  { code: 'SO', name: 'Somalia', flag: 'somalia' },
  { code: 'SR', name: 'Suriname', flag: 'suriname' },
  { code: 'SS', name: 'South Sudan', flag: 'worldwide' },
  { code: 'ST', name: 'Sao Tome And Principe', flag: 'sao_tome_principe' },
  { code: 'SV', name: 'El Salvador', flag: 'el_salvador' },
  { code: 'SX', name: 'Sint Maarten (Dutch part)', flag: 'worldwide' },
  { code: 'SY', name: 'Syrian Arab Republic', flag: 'syria' },
  { code: 'SZ', name: 'Swaziland', flag: 'swaziland' },
  {
    code: 'TC',
    name: 'Turks And Caicos Islands',
    flag: 'turksandcaicosislands'
  },
  { code: 'TD', name: 'Chad', flag: 'chad' },
  { code: 'TF', name: 'French Southern Territories', flag: 'worldwide' },
  { code: 'TG', name: 'Togo', flag: 'togo' },
  { code: 'TH', name: 'Thailand', flag: 'thailand' },
  { code: 'TJ', name: 'Tajikistan', flag: 'tajikistan' },
  { code: 'TK', name: 'Tokelau', flag: 'tokelau' },
  { code: 'TL', name: 'Timor-Leste', flag: 'easttimor' },
  { code: 'TM', name: 'Turkmenistan', flag: 'turkmenistan' },
  { code: 'TN', name: 'Tunisia', flag: 'tunisia' },
  { code: 'TO', name: 'Tonga', flag: 'tonga' },
  { code: 'TR', name: 'Turkey', flag: 'turkey' },
  { code: 'TT', name: 'Trinidad And Tobago', flag: 'trinidad_tobago' },
  { code: 'TV', name: 'Tuvalu', flag: 'worldwide' },
  { code: 'TW', name: 'Taiwan', flag: 'taiwan' },
  { code: 'TZ', name: 'Tanzania', flag: 'tanzania' },
  { code: 'UA', name: 'Ukraine', flag: 'ukraine' },
  { code: 'UAE', name: 'United Arab Emirates', flag: 'dubai' },
  { code: 'UG', name: 'Uganda', flag: 'uganda' },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    flag: 'worldwide'
  },
  { code: 'US', name: 'United States', flag: 'usa' },
  { code: 'UY', name: 'Uruguay', flag: 'uruguay' },
  { code: 'UZ', name: 'Uzbekistan', flag: 'uzbekistan' },
  {
    code: 'VA',
    name: 'Vatican City State',
    flag: 'vaticancity',
    tags: 'Holy See'
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    flag: 'stvincentthegrenadines'
  },
  { code: 'VE', name: 'Venezuela', flag: 'venezuela' },
  { code: 'VG', name: 'Virgin Islands British', flag: 'virginislandsbritish' },
  { code: 'VI', name: 'Virgin Islands U.S.', flag: 'virginislandsus' },
  { code: 'VN', name: 'Viet Nam', flag: 'vietnam' },
  { code: 'VU', name: 'Vanuatu', flag: 'vanuatu' },
  { code: 'WF', name: 'Wallis and Futuna', flag: 'worldwide' },
  { code: 'WS', name: 'Samoa', flag: 'samoa' },
  { code: 'XK', name: 'Kosovo', flag: 'worldwide' },
  { code: 'YE', name: 'Yemen', flag: 'yemen' },
  { code: 'YT', name: 'Mayotte', flag: 'worldwide' },
  { code: 'ZA', name: 'South Africa', flag: 'south_africa' },
  { code: 'ZM', name: 'Zambia', flag: 'zambia' },
  { code: 'ZW', name: 'Zimbabwe', flag: 'zimbabwe' }
];
